
<template>

  <el-card class="article_card">
    <template #header>
      <div class="card-header">
        <span><RouterLink :to="{ name: 'row', params: { id: id }}">{{ arc_title }}</RouterLink></span>
      </div>
    </template>
    <div class="dsc" v-html="desc"></div>

  </el-card>
</template>
<script>
export default {
  props: ['arc_title','desc','id'],
  setup() {

    return {

    }
  }
}
</script>
<style scoped>

</style>